import { EndPoints } from "settings/endpoints";
import axiosInstance from "../../services/axios";
import { ActionTypes } from "../type";
import { validateToken } from "services/jwt";
import zoneLocalStorageId from "utils/zone";

const zone_id = Number(localStorage.getItem("zone_id"));

const getLoginDetails = (state) => {
  const login = state.jwtAuthreducer;
  return {
    zone_id,
    f_is_franchise_employee: Number(
      login.is_franchise_employee
        ? login.is_franchise_employee
        : localStorage.getItem("is_franchise_employee"),
    ),
    f_franchise_id: Number(
      login?.franchise_id
        ? login?.franchise_id
        : localStorage.getItem("franchise_id"),
    ),
    f_is_super_franchise: Number(
      login?.is_super_franchise
        ? login?.is_super_franchise
        : localStorage.getItem("is_super_franchise"),
    ),
    sub_franchise: Number(
      login?.sub_franchise
        ? login?.sub_franchise
        : localStorage.getItem("sub_franchise"),
    ),
  };
};

const getFranchiseParams = (state) => {
  const {
    f_is_franchise_employee,
    f_franchise_id,
    f_is_super_franchise,
    sub_franchise,
  } = getLoginDetails(state);
  return {
    f_is_franchise_employee,
    f_franchise_id,
    f_is_super_franchise,
    sub_franchise,
  };
};

export const getAreaList = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(
      "LIS/master/list/areamaster",
      {
        params: {
          limit: 10,
          page_no: 0,
          is_active: true,
          zone_id,
        },
      },
    );
    dispatch({
      type: ActionTypes.AREA_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getStateList = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get("LIS/get_state/IN", {
      params: {
        zone_id,
      },
    });
    dispatch({
      type: ActionTypes.STATE_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getDoctorList = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = {
      zone_id,
      doctor_type: "EXTERNAL",
      is_active: true,
      ...getFranchiseParams(state),
    };
    const { data } = await axiosInstance.get(
      "LIS/master/list/doctormaster_dd",
      { params },
    );
    dispatch({ type: ActionTypes.DOCTOR_LIST_DROPDOWN, payload: data });
  } catch (err) {
    console.error("Error fetching doctor list:", err);
  }
};

export const getCollectionTypeList = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(
      "LIS/master/list/collectiontypemaster",
      {
        params: {
          zone_id,
        },
      },
    );
    dispatch({
      type: ActionTypes.COLLECTION_TYPE_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getFranchiseTypesList = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = { zone_id, ...getFranchiseParams(state) };
    const { data } = await axiosInstance.get(
      "LIS/master/list/franchisetypes",
      { params },
    );
    dispatch({ type: ActionTypes.FRANCHISE_TYPE_LIST_DROPDOWN, payload: data });
  } catch (err) {
    console.error("Error fetching doctor list:", err);
  }
};

export const getFranchiseList = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = {
      limit: 2000,
      page_no: 0,
      is_active: true,
      zone_id,
      ...getFranchiseParams(state),
    };
    const { data } = await axiosInstance.get(EndPoints.Franchise.LIST_DD, {
      params,
    });
    dispatch({ type: ActionTypes.FRANCHISE_LIST_DROPDOWN, payload: data });
  } catch (err) {
    console.error("Error fetching franchise list:", err);
  }
};

export const getPaymentModeList = (b2c) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(
      "accounts/master/list/paymentmodemaster",
      {
        params: {
          zone_id,
          ...(b2c && { b2c: true }),
        },
      },
    );
    dispatch({
      type: ActionTypes.PAYMENT_MODE_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getInvestigationList =
  (lab_department_ids = []) =>
  async (dispatch, getState) => {
    try {
      const state = getState();

      const extraParams = new URLSearchParams();
      lab_department_ids.forEach((id) => {
        extraParams.append("lab_department_ids", id);
      });

      const params = {
        limit: 2000,
        ...getFranchiseParams(state),
      };

      const { data } = await axiosInstance.get(
        "LIS/master/list/investigationmaster_dd",
        {
          params,
          paramsSerializer: (p) => {
            const base = new URLSearchParams(p).toString();
            const extra = extraParams.toString();
            return extra ? `${base}&${extra}` : base;
          },
        },
      );

      dispatch({
        type: ActionTypes.INVESTIGATION_LIST_DROPDOWN,
        payload: data,
      });
    } catch (err) {
      console.error("Error fetching investigation list:", err);
    }
  };

export const getCollectionBoyList = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(`hrms/master/list/employee`, {
      params: {
        limit: 10,
        page_no: 0,
        employee_category_id: 5,
        is_active: true,
        zone_id,
      },
    });
    dispatch({
      type: ActionTypes.COLLECTION_BOY_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getDeliveryBoyList = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(`hrms/master/list/employee`, {
      params: {
        limit: 10,
        page_no: 0,
        employee_category_id: 2,
        is_active: true,
        zone_id,
      },
    });
    dispatch({
      type: ActionTypes.DELIVERY_BOY_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getEmployeeList = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = {
      limit: 10,
      page_no: 1,
      keyword: "department",
      is_active: true,
      zone_id,
      ...getFranchiseParams(state),
    };
    const { data } = await axiosInstance.get(`hrms/master/list/employee`, {
      params,
    });
    dispatch({ type: ActionTypes.EMPLOYEE_LIST_DROPDOWN, payload: data });
  } catch (err) {
    console.error("Error fetching Employee list:", err);
  }
};

export const getZoneList = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = {
      limit: 10,
      page_no: 1,
      keyword: "zone_name",
      text: "",
      is_active: true,
      zone_id,
      ...getFranchiseParams(state),
    };
    const { data } = await axiosInstance.get(EndPoints.ZONELISTDD, { params });
    dispatch({ type: ActionTypes.ZONE_LIST_DROPDOWN, payload: data });
  } catch (err) {
    console.error("Error fetching Zone list:", err);
  }
};

export const getBarcode = (franchise_id) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get("LIS/franchise/get/barcode", {
      params: {
        franchise_id,
        zone_id,
      },
    });
    dispatch({
      type: ActionTypes.BAR_CODE_INFO,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const clearBarcode = (franchise_id) => async (dispatch) => {
  try {
    dispatch({
      type: ActionTypes.CLEAR_BAR_CODE_INFO,
    });
  } catch (err) {
    // throw err;
  }
};

export const getReceptInfo = (registartion_id) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(
      "LIS/new/registration/get_registration_detail",
      {
        params: {
          registartion_id,
          zone_id,
        },
      },
    );
    dispatch({
      type: ActionTypes.RECEIPT_INFO,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getDepartmentList = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(
      `LIS/master/list/departmenttypemaster`,
      {
        params: {
          limit: 2000,
          page_no: 0,
          is_active: true,
          zone_id,
        },
      },
    );
    dispatch({
      type: ActionTypes.DEPARTMENT_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getLabDepartmentList = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(
      `LIS/master/list/labdepartmentmaster`,
      {
        params: {
          limit: 2000,
          page_no: 0,
          is_active: true,
          zone_id,
        },
      },
    );
    dispatch({
      type: ActionTypes.LAB_DEPARTMENT_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getStatusList = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(
      `/LIS/master/list/appointmentstatusmaster`,
      {
        params: {
          limit: 100,
          page_no: 0,
          is_active: true,
          zone_id,
        },
      },
    );
    dispatch({
      type: ActionTypes.STATUS_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    // throw err;
  }
};

export const getPackageList = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = {
      limit: 2000,
      page_no: 0,
      is_active: true,
      zone_id,
      ...getFranchiseParams(state),
    };
    const { data } = await axiosInstance.get(
      `LIS/master/list/packagemaster`,
      { params },
    );
    dispatch({ type: ActionTypes.PACKAGE_LIST_DROPDOWN, payload: data });
  } catch (err) {
    console.error("Error fetching Zone list:", err);
  }
};

export const getBarcodeImage = (payload) => async (dispatch) => {
  try {
    const { barcodeData } = payload;
    if (payload?.token) {
      if (validateToken(payload?.token)) {
        const { data } = await axiosInstance.post(
          `/LIS/barcode/master/print_barcode`,
          barcodeData,
          {
            headers: {
              Authorization: `Bearer ${payload?.token}`,
            },
          },
        );
        dispatch({
          type: ActionTypes.GET_BARCODE_IMAGE,
          payload: data,
        });
      }
      return;
    } else {
      const { data } = await axiosInstance.post(
        `/LIS/barcode/master/print_barcode`,
        barcodeData,
      );
      dispatch({
        type: ActionTypes.GET_BARCODE_IMAGE,
        payload: data,
      });
    }
  } catch (err) {
    // throw err;
  }
};

export const getFranchisePackageListDD = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const franchise_id = localStorage.getItem("franchise_id");
    const params = {
      limit: 2000,
      page_no: 0,
      is_active: true,
      // zone_id,
      franchise_id,
      ...getFranchiseParams(state),
    };
    const { data } = await axiosInstance.get(
      `LIS/master/list/franchise_package_dd`,
      { params },
    );
    dispatch({
      type: ActionTypes.FRANCHISE_PACKAGE_LIST_DD_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    console.error("Error fetching Zone list:", err);
  }
};

export const getDiscountReasonList = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = { limit: 2000, zone_id, ...getFranchiseParams(state) };
    const { data } = await axiosInstance.get(
      "LIS/master/list/discount_reasonmaster",
      { params },
    );
    dispatch({
      type: ActionTypes.DISCOUNT_REASON_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    console.error("Error fetching investigation list:", err);
  }
};

export const getAgentList = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const params = { limit: 2000, zone_id, ...getFranchiseParams(state) };
    const { data } = await axiosInstance.get(
      "hrms/master/list/patient_coordinator_agent_dd",
      { params },
    );
    dispatch({
      type: ActionTypes.AGENT_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    console.error("Error fetching investigation list:", err);
  }
};

export const getMembershipCardList = () => async (dispatch, getState) => {
  try {
    const params = {
      zone_id: zoneLocalStorageId(),
      is_active: true,
    };
    const { data } = await axiosInstance.get(
      "LIS/master/list/membership_card_dd",
      { params },
    );
    dispatch({
      type: ActionTypes.MEMBERSHIP_CARD_LIST_DROPDOWN,
      payload: data,
    });
  } catch (err) {
    console.error("Error fetching membership card list:", err);
  }
};
